
export const getLogoBase64 = async (): Promise<string> => {
    try {
        const response = await fetch('/logo.png');
        if (!response.ok) throw new Error('Failed to fetch logo');
        const blob = await response.blob();
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result as string);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
        });
    } catch (error) {
        console.error('Error loading logo:', error);
        return '';
    }
};
